export function getItemNodeFormatting(heading, values) {
    const formatter = (value) => {
        if (value !== null && value !== undefined && heading.formatter) {
            return heading.formatter(value);
        }
        return value;
    };
    return formatter(values[heading.key]);
}
export function getItemStringFormatting(heading, values) {
    const formatter = (value) => {
        if (value !== null && value !== undefined && heading.tipFormatter) {
            return heading.tipFormatter(value);
        }
        return value;
    };
    return `${formatter(values[heading.key])}`;
}
export function getDataTestId(heading, rowId) {
    return heading.dataTestId && `${heading.dataTestId}-${rowId}`;
}
export const getCellId = (id, rowId) => id && `${id}__rowId-${rowId}`;
export const getCellDataTestId = (rowIndex, dataTestId) => dataTestId && `${dataTestId}-row-${rowIndex}-col-`;
export const getCellDataId = (rowIndex, dataId) => dataId && `${dataId}-row-${rowIndex}-col-`;
export const getHiddenClassesFromBreakpoints = (points) => points?.reduce((css, point) => `${css} hidden-${point}`, "") ?? "";
export const getTableColumnWidth = (width) => width ? `table__column ${getColumnWidthClassName(width)}` : "";
export const getColumnWidthClassName = (width) => `column-width--${width}`;
